import { render, staticRenderFns } from "./AccountAvatarForm.vue?vue&type=template&id=724ba118&scoped=true"
import script from "./AccountAvatarForm.vue?vue&type=script&lang=js"
export * from "./AccountAvatarForm.vue?vue&type=script&lang=js"
import style0 from "./AccountAvatarForm.vue?vue&type=style&index=0&id=724ba118&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724ba118",
  null
  
)

export default component.exports